import styled from 'styled-components/macro'

const SelectedFilter = styled.div`
  padding: 4px 10px 4px 6px;
  margin: 3px;
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
  border-radius: 2px;
  color: white;
  display: block;
  position: relative;
  background-color: white;
  ${props =>
    props.isCapitalized &&
    `
    &:first-letter {
    text-transform: uppercase;
  }
  `}
`

export default SelectedFilter
